import { get, put, post, del, default as com } from '@/common/api'

let api = {
  /** ****************** 全局配置操作接口 ****************** **/
  queryRegSetting: (para) => {
    return get('/api/op/regSetting', para)
  },
  saveRegSetting: (para) => {
    return post('/api/op/regSetting', para)
  },
  // 根据id取的实体信息
  getRegSetting: (id) => {
    return get(`/api/op/regSetting/${id}`)
  },
  delRegSetting: (id) => {
    return del(`/api/op/regSetting/${id}`)
  },


  /** ****************** 门诊信息操作接口 {科室，专家} ****************** **/
  queryTarget: (para) => {
    return get('/api/op/regTarget', para)
  },
  // saveOutpatient:(para)=>{
  //       if(para.id){
  //        return  put(`/api/op/regOutpatient/${para.id}`,para)
  //       }else{
  //         return post('/api/op/regOutpatient/addMutli', para)
  //       }
  // },
  // 根据id取的实体信息
  getOutpatient: (id) => {
    return get(`/api/op/regTarget/${id}`)
  },
  // delOutpatient:(id)=>{
  //  return  del(`/api/op/regTarget/${id}`)
  // },


  /** 批量添加门诊科室输入信息 **/
  addMutli: (para) => {
    return post('/api/op/regTarget/addMutli', para)
  },


  /** ****************** 租户科室，门诊 ****************** **/

  getTenantDept: (para) => {
    return get('/api/md/dept', para)
  },

  getTenantExpert: (para) => {
    return get('/api/md/staff/expert', para)
  },

  /** ****************** 号池编辑接口 ****************** **/
  getRegPeriods:(para)=> {
    return get(`/api/op/regStatistic/periodList`, para)
  },
  getAllRegs:(para)=> {
    return get('/api/op/reg/all', para)
  },
  addRegs:(para)=> {
    return post(`/api/op/reg/addRegNo`, para)
  },
  createReg:(para)=> {
    return post('/api/op/reg/creation', para)
  },
  // 查询就诊号预览
  getRegNo: (para) => {
    return get('/api/op/reg/preview', para);
  },
  delReg:(id)=> {
    return del(`/api/op/reg/${id}`)
  },
  recoveryReg:(id)=>{
    return put(`/api/op/reg/recovery/${id}`)
  },
  /***********************  就诊号类别信息  ***********************/

  queryRegType: com.queryRegType,
  queryPeriodList: com.queryPeriodList,

  // 查询排班表格信息
  getRegRota: (para) => {
    return get('/api/op/regRota/table', para);
  },

  saveRegRota: (para) => {
    return post('/api/op/regRota/table', para);
  },
  // 查询就诊号预览
  getRegStatisticPeriod: (para) => {
    return get('/api/op/regStatistic/preview', para);
  },
  // 查询就诊号预览
  queryRegStatisticPeriod: (para) => {
    return post('/api/op/regStatistic/all/preview', para);
  },
  // 查询余号
  queryValidReg(para) {
    return get('/api/op/regStatistic/rest', para)
  },
  // 查询医生一段时间余号
  queryDoctorValidReg(para) {
    return get('/api/op/regStatistic/doctor', para)
  },
  // 查询停诊信息
  querySuspend: (para) => {
    return get('/api/op/regSuspend', para);
  },
  addSuspend: (para) => {
    return post('/api/op/regSuspend', para)
  },
  // 删除
  delSuspend: (id) => {
    return del(`/api/op/regSuspend/${id}`)
  },

  /***********************  渠道  ***********************/
  queryChannel: com.queryChannel,
  queryAlloc: para => get(`/api/op/regChannelAlloc`, para),
  saveAlloc: para => para.id ? put(`/api/op/regChannelAlloc/${para.id}`, para) : post(`/api/op/regChannelAlloc`, para)
}
export default api
